export default __webpack_public_path__ + "static/media/nodeJs.5d6cbbc1.svg";